<div class="app-base-container">
  <div class="app-container">

    <div class="app-header app-container-shadow">
      <div class="app-header__container">
        <div class="app-header__item">
          <a class="app-header__logo" routerLink="/">
            <img src="/assets/img/logo.jpg" />
          </a>
          <div class="tag">Тендерная площадка</div>
          <a href="https://sale.agparitet.ru/" target="_blank" class="tag" style="margin-left: 20px;">Реализация неликвидов</a>
        </div>
        <div class="app-header__item">
        </div>
        <div *ngIf="api.token else elseBlockAuth" class="app-header__item">
          <span class="app-header__fio">{{api.fio}}</span>
          <button mat-icon-button class="app-header__exit" (click)="logout()">
            <mat-icon matSuffix>exit_to_app</mat-icon>
          </button>
        </div>
        <ng-template #elseBlockAuth>
          <div class="app-header__item">
            <a href="javascript:void(0)" class="app-header__link" (click)="authClick()">Войти</a>&nbsp;|&nbsp;<a
              href="javascript:void(0)" routerLink="/registration" class="app-header__link">Регистрация</a>
          </div>
        </ng-template>
      </div>
    </div>

    <mat-sidenav-container class="app-body app-container-shadow">
      <mat-sidenav mode="side" opened>
        <nav-menu class="app-container-shadow" [parent]="this"></nav-menu>
      </mat-sidenav>

      <mat-sidenav-content class="app-content">
        <router-outlet></router-outlet>
      </mat-sidenav-content>
    </mat-sidenav-container>

  </div>
</div>
